import React from 'react';
import './App.css';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from './helper/authConfig';

import LoginScreen from './components/LoginScreen';
import UserScreen from './components/UserScreen';
import AdminScreen from './components/AdminScreen';
import NewsletterQnA from './components/NewsletterQnA';
import { useAppState } from './hooks/useAppState';

const apiRootUrl = process.env.REACT_APP_API_ROOT_ENDPOINT;

function App() {
    const { instance, accounts } = useMsal();

    const {
        data,
        error,
        selectedYear,
        selectedWeek,
        selectedEntities,
        entityRef,
        entityRefLoading,
        isAdmin,
        adminToken,
        users,
        distributions,
        qnaQuestion,
        setQnaQuestion,
        qnaFromYear,
        setQnaFromYear,
        qnaFromMonth,
        setQnaFromMonth,
        qnaThruYear,
        setQnaThruYear,
        qnaThruMonth,
        setQnaThruMonth,
        qnaAnswer,
        qnaLoading,
        qnaError,
        showSubscriptionForm,
        showUploadPdf,
        showAdmin,
        showNewsletterQnA,
        toggleSubscriptionForm,
        toggleUploadPdf,
        toggleAdminScreen,
        toggleNewsletterQnA,
        activeAccount,
        handleLogin,
        handleNewsletterQnASubmit,
        handleChangeWeek,
        handleChangeEntities,
        setUsers,
        setDistributions,
        saveUser,
        deleteUser,
        saveDist,
        deleteDist,
        setShowAdmin,
        currentYear
    } = useAppState({ instance, accounts, apiRootUrl });

    if (error) return <div>Error: {error.message}</div>;

    return (
        <div className="App">
            {!accounts.length || !activeAccount ? (
                <LoginScreen handleLogin={handleLogin} />
            ) : (
                showAdmin ? (
                    <AdminScreen
                        isAdmin={isAdmin}
                        users={users}
                        setUsers={setUsers}
                        distributions={distributions}
                        setDistributions={setDistributions}
                        onSaveUser={saveUser}
                        onDeleteUser={deleteUser}
                        onSaveDist={saveDist}
                        onDeleteDist={deleteDist}
                        onClose={toggleAdminScreen}
                    />
                ) : showNewsletterQnA ? (
                    <NewsletterQnA
                        onClose={toggleNewsletterQnA}
                        question={qnaQuestion}
                        setQuestion={setQnaQuestion}
                        fromYear={qnaFromYear}
                        setFromYear={setQnaFromYear}
                        fromMonth={qnaFromMonth}
                        setFromMonth={setQnaFromMonth}
                        thruYear={qnaThruYear}
                        setThruYear={setQnaThruYear}
                        thruMonth={qnaThruMonth}
                        setThruMonth={setQnaThruMonth}
                        answer={qnaAnswer}
                        loading={qnaLoading}
                        error={qnaError}
                        onSubmit={handleNewsletterQnASubmit}
                        currentYear={currentYear}
                        instance={instance}
                        loginRequest={loginRequest}
                    />
                ) : (
                    <UserScreen
                        selectedYear={selectedYear}
                        selectedWeek={selectedWeek}
                        handleChangeWeek={handleChangeWeek}

                        entityRef={entityRef}
                        selectedEntities={selectedEntities}
                        handleChangeEntities={handleChangeEntities}
                        entityRefLoading={entityRefLoading}

                        setShowAdmin={setShowAdmin}

                        toggleUploadPdf={toggleUploadPdf}
                        toggleSubscriptionForm={toggleSubscriptionForm}
                        toggleNewsletterQnA={toggleNewsletterQnA}

                        showSubscriptionForm={showSubscriptionForm}
                        showUploadPdf={showUploadPdf}

                        isAdmin={isAdmin}
                        adminToken={adminToken}
                        apiRootUrl={apiRootUrl}
                        data={data}

                        instance={instance}
                        accounts={accounts}
                        loginRequest={loginRequest}
                    />
                )
            )}
        </div>
    );
}

export default React.memo(App);